import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';

const Hero = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={2}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '16vh',
          }}
        />

        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          variant="overline"
          color="textSecondary"
          align="center"
          display="block"
          gutterBottom
        >
          Propuesta Integral de Lanzamiento
        </Typography>

        <Box
          component={Typography}
          fontWeight={700}
          variant="h3"
          gutterBottom
          align="center"
          color={theme.palette.primary.main}
          sx={{ px: 1 }}
        >
          Danimar & TNO Network & Expedientes del Delito
        </Box>

        <Typography
          variant="h6"
          component="p"
          color="textSecondary"
          align="center"
          sx={{ fontStyle: 'italic', mb: 1 }}
        >
          Justicia Implacable contra la Suciedad
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          align="center"
          sx={{ mb: 3, maxWidth: 640, mx: 'auto' }}
        >
          Limpieza con evidencia | Expedientes del Delito
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 3,
          }}
        >
          <Box
            component="img"
            src="/images/logodanimar.jpg"
            alt="Danimar"
            sx={{
              width: 120,
              height: 120,
              objectFit: 'contain',
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </Box>

        <Box
          sx={{
            maxWidth: 720,
            mx: 'auto',
            py: 2,
            px: 2,
            borderRadius: 2,
            bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
          }}
        >
          <Typography
            variant="h6"
            component="p"
            color="textSecondary"
            align="center"
            gutterBottom
          >
            <strong>Concepto: &quot;Caso Cerrado&quot;</strong>
          </Typography>
          <Typography variant="body1" color="textSecondary" align="center" paragraph>
            En la limpieza, como en la justicia, no puede quedar rastro. Danimar se presenta con tono de
            <strong> campaña de intriga</strong>: frases cortas, contundentes y atmósfera de resolución profesional en estudio.
          </Typography>
          <Typography variant="body1" color="textSecondary" align="center">
            Con el rigor de <strong>Expedientes del Delito</strong>, la marca entra al set como evidencia clave:
            <strong> evidencia en estudio</strong>, aplicación precisa y veredicto verificable.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

Hero.propTypes = {
  themeMode: PropTypes.string,
};

export default Hero;

